/**
 * Appends a voice transcription onto a question's existing answer value.
 *
 * A non-string prior value is dropped, not coerced. SurveySession keeps ONE `useState<any>` for
 * the current answer across every question type, but the mic is only rendered for `long_text` /
 * `short_text` and for follow-ups (both free text) — so a non-string here is always an
 * already-submitted answer from an earlier question that leaked into state, never an answer to
 * this one. Interpolating it produced "[object Object] <transcript>" in stored responses.
 */

const JOIN_SEPARATOR = ' ';

export function appendTranscript(previousValue: unknown, transcribedText: string): string {
  const previousText =
    typeof previousValue === 'string' && previousValue.trim().length > 0 ? previousValue : '';

  if (!previousText) return transcribedText;
  if (!transcribedText) return previousText;

  return `${previousText}${JOIN_SEPARATOR}${transcribedText}`;
}
